import { render } from "./RecipeSaveBtn.vue?vue&type=template&id=39002401&scoped=true"
import script from "./RecipeSaveBtn.vue?vue&type=script&lang=js"
export * from "./RecipeSaveBtn.vue?vue&type=script&lang=js"

import "./recipeSaveBtn.css?vue&type=style&index=0&id=39002401&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39002401"]])

export default __exports__